import { PasswordInput } from '../../input/password-input';
import { LabeledComponent, LabeledComponentGroup } from '../../labeled-component/labeled-component';
import { DialogBody } from '../dialog';
import { usePasswordChange } from './hooks/use-password-change';

type Props = {
  /** 変更完了メッセージのOK押下時の処理 */
  onComplete: () => void,
  /** キャンセル押下時の処理 */
  onCancel: () => void,
}

export const PasswordChangeDialog = (props: Props) => {
  const {
    Footer,
    request,
    setRequest,
    validation,
  } = usePasswordChange(props);

  return (
    <DialogBody
      bodyProps={{ w: '600px', maxW: '100%', minW: '200px' }}
      footer={<Footer />}
    >
      <LabeledComponentGroup labelWidth='190px' minW="calc(350px + 1rem)">
        <LabeledComponent label="現在のパスワード" require>
          <PasswordInput
            placeholder="現在のパスワード"
            value={request.current_password}
            onChange={(e) => setRequest({ current_password: e.target.value })}
            validations={validation.current_password}
          />
        </LabeledComponent>
        <LabeledComponent label="新しいパスワード" require>
          <PasswordInput
            placeholder="新しいパスワード"
            value={request.password}
            onChange={(e) => setRequest({ password: e.target.value })}
            validations={validation.password}
          />
        </LabeledComponent>
        <LabeledComponent label="新しいパスワード(確認用)" require>
          <PasswordInput
            placeholder="新しいパスワード（確認用）"
            value={request.password_confirmation}
            onChange={(e) => setRequest({ password_confirmation: e.target.value })}
            validations={validation.password_confirmation}
          />
        </LabeledComponent>
      </LabeledComponentGroup>
    </DialogBody>
  )
}
